import { observer } from 'mobx-react-lite'
import { StyleSheet, View, Dimensions, useWindowDimensions } from 'react-native'
import { useStore } from '../../../models'
import { PlayerChips } from '../PlayerChips'
import { PlayerRole } from '../PlayerRole'
import { useTableTourPositioning } from '../../../hooks/usePositioning'
import { DS } from '../../../design-system'
import MyFirstGameStepNames from '../../../models/game/first-game/MyFirstGameStepNames'
import { useLayoutShiftRegistry } from '@/hooks/useLayoutShiftRegistry'

export const PlayerInfo = observer(() => {
  const {
    game: { myPlayer, isMyPlayerObserver, isMyFirstGame, stageInternalName }
  } = useStore()

  const { register } = useLayoutShiftRegistry()

  const { ref, onLayout } = useTableTourPositioning({ key: 'chips', shouldSave: () => true })
  const { width: windowWidth } = useWindowDimensions()

  if (!myPlayer) return null

  return (
    <View style={styles.container} onLayout={(e) => register('myFirstGame.playerInfo', e)}>
      {myPlayer.role ? (
        <PlayerRole
          role={myPlayer.role as PlayerRole}
          size={isMyFirstGame && stageInternalName === MyFirstGameStepNames.roles ? 'medium' : undefined}
        />
      ) : null}

      <DS.Text
        variant="Caption/Bold"
        numberOfLines={1}
        style={[styles.name, { paddingLeft: myPlayer.role ? 10 : 0, flex: windowWidth < 390 ? 0.85 : 1 }]}
      >
        {myPlayer.name}
      </DS.Text>

      <DS.Text
        variant="Mini/Medium"
        uppercase
        textAlign={'center'}
        style={{ flex: windowWidth < 380 ? 1.2 : 1, marginRight: myPlayer.role ? 32 : 0 }}
      >
        {myPlayer.rankedHandName}
      </DS.Text>

      <View ref={ref} onLayout={onLayout} collapsable={false} style={{ flex: windowWidth < 390 ? 0.85 : 1 }}>
        {!isMyPlayerObserver ? (
          <PlayerChips
            chips={myPlayer.chips}
            color="Global/Black"
            right
            chipsSize={18}
            variant={isMyFirstGame ? 'Caption/Bold' : undefined}
          />
        ) : null}
      </View>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexGrow: 1,
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  name: {
    flexShrink: 1,
    paddingLeft: 10,
    overflow: 'hidden'
  }
})
